import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { getUserInfo, getDashboard } from './functions/userInfo'

function Protected(props) {
    let userObj = getUserInfo();
    let Component = props.cmp;
    let [allow, setAllow] = useState(false);
    const navigate = useNavigate();
    const dashboard = userObj.userType === 'account_user'?sessionStorage.getItem('Dashboards') ? getDashboard() : []:[];
    let admin = ['/accounts', '/assets-lists', '/asset-onboarding', '/asset-onboarding/:assetInfoId', '/asset-user-mapping', '/service-request-list', '/dashboard-group-creation', '/dashboard-group-mapping', '/fuel_tank_capacity', '/profile', '/adminUser', '/technician-master', '/godrej-user-List','/asset-upload'];
    let user = ['/my-equipment', '/home', '/utilization', '/operator', '/fuel-consumption', '/service-request', '/impact', '/maintenance', '/incident', '/geo', '/imp-parameter', '/service-request-list', '/shift-master', '/profile','/createGeo','/assetlocation','/location_tracking','/notification'];//'/createGeofence'
    let tech_user = ['/preventive_maintenance', '/profile'];
    const dashIdObj = {
        '/utilization':1, 
        '/service-request':2, 
        '/imp-parameter':3, 
        '/geo':4, 
        '/maintenance':5, 
        '/fuel-consumption':6, 
        '/operator':7, 
        '/incident':8, 
        '/impact':9, 
        '/service-request-list':10, 
        '/my-equipment':11,
        '/shift-master':12, 
        '/home':13, 
        '/createGeo':14,
        '/location_tracking':15,
        '/profile':0,
        '/assetlocation':0,
        '/notification':0
    };
    const location = useLocation();
    // check is user authenticate and what is type of user
    useEffect(() => {
        if (sessionStorage.getItem('userInfo') && sessionStorage.getItem('userInfo') != 'undefined') {
            // let userObj = getUserInfo();
            //console.log("login")
            setAllow(true);
            if (userObj.userType === 'admin' && admin.indexOf(location.pathname) >= 0 || userObj.userType === 'admin' && location.pathname.includes("/asset-onboarding/")) {

            }
            else if (userObj.userType === 'account_user' && user.indexOf(location.pathname) >= 0) {
                if(checkAlowedDash(location.pathname)){

                }
                else{
                    if(dashboard.indexOf(11) >= 0){
                        navigate(user[0]);
                    }
                    else{
                        navigate('/profile');
                    }
                }
            }
            else if (userObj.userType === 'technician_user' && tech_user.indexOf(location.pathname) >= 0) {

            }
            else {
                if (userObj.userType === 'admin') {
                    navigate(admin[0]);
                }
                else if (userObj.userType === 'account_user') {
                    if(dashboard.indexOf(11) >= 0){
                        navigate(user[0]);
                    }
                    else{
                        navigate('/profile');
                    }
                }
                else if (userObj.userType === 'technician_user') {
                    navigate('/preventive_maintenance');
                }
                else {
                    navigate('/404');
                }
            }
        }
        else {
            //console.log("logout")
            setAllow(false);
            props.aapFun(false);
            navigate('/login');
        }
    }, []);

    function checkAlowedDash(name){
        const id = dashIdObj[name];
        if(id == 0){
            return true;
        }
        else if(dashboard.indexOf(id) >= 0){
            return true
        }
        else{
            return false;
        }
    }


    return (
        <>
            {
                allow ? <Component /> : <></>
            }
        </>
    )
}

export default Protected
